import { render, staticRenderFns } from "./lottie.vue?vue&type=template&id=75b0642e&scoped=true"
import script from "./lottie.vue?vue&type=script&lang=js"
export * from "./lottie.vue?vue&type=script&lang=js"
import style0 from "./lottie.vue?vue&type=style&index=0&id=75b0642e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b0642e",
  null
  
)

export default component.exports